<!-- <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
  <ion-refresher-content pullingIcon="chevron-down-circle-outline" pullingText="Pull to refresh"
    refreshingSpinner="bubbles" refreshingText="Refreshing..." col>
  </ion-refresher-content>
</ion-refresher> -->


<div class="wrap" *ngIf="menu">

  <div *ngFor="let m of menu">
    <mat-card
      *ngIf="m.visibilityFlag && m.menuType != 'Lien Externe Navigateur' && m.menuType != 'Application Mobile' && m.menuType != 'PDF'"
      (click)=" getLink(m.menuType, m.lien, m.url, m.addPersona, m.addFonction, m.title_Home)">
      <div class="thumbnail">
        <div class="thumbnail_img_and_content">
          <div class="thumbnail_img">
            <app-img-icone [src]="m.svg_White"></app-img-icone>
          </div>
          <div class="thumbnail_content">
            <h3>{{m.title_Home}}</h3>
            <p>{{m.description}}</p>
          </div>
        </div>
        <div class="next">
          <fa-icon [icon]="faArrowRight"></fa-icon>
        </div>
      </div>
    </mat-card>
    <a [href]="m.url" *ngIf="m.adId">
      <mat-card class="pub">
        <img [src]="m.image">
      </mat-card>
    </a>

    <mat-card *ngIf="m.visibilityFlag && m.menuType === 'Application Mobile'" (click)="invokeAppAction(m.url)">
      <div class="thumbnail">
        <div class="thumbnail_img_and_content">
          <div class="thumbnail_img">
            <app-img-icone [src]="m.svg_White"></app-img-icone>
          </div>
          <div class="thumbnail_content">
            <h3>{{m.title_Home}}</h3>
            <p>{{m.description}}</p>
          </div>
        </div>
        <div class="next">
          <fa-icon [icon]="faArrowRight"></fa-icon>
        </div>
      </div>
    </mat-card>
    <mat-card *ngIf="m.visibilityFlag && m.menuType == 'Lien Externe Navigateur' || m.menuType == 'PDF' ">
      <a [href]="getLinkExternal(m)">
        <div class="thumbnail">
          <div class="thumbnail_img_and_content">
            <div class="thumbnail_img">
              <app-img-icone [src]="m.svg_White"></app-img-icone>
            </div>
            <div class="thumbnail_content">
              <h3>{{m.title_Home}}</h3>
              <p>{{m.description}}</p>
            </div>
          </div>
          <div class="next">
            <fa-icon [icon]="faArrowRight"></fa-icon>
          </div>
        </div>
      </a>
    </mat-card>

  </div>

  <div class="connexion" [routerLink]="['/login']" routerLinkActive="router-link-active" *ngIf="!isConnect">
    <p>Connexion à votre espace personnel</p>
  </div>
</div>

<app-skeleton-menu-home *ngIf="!menu"></app-skeleton-menu-home>